import { useTranslation } from "react-i18next";
import { Form, Icon } from "semantic-ui-react";

import { Element } from "components/ReactScroll/index";
import { createFormHelper } from "lib/Form";
import { ASTERISK_PLACEHOLDER } from "modules/DealerOverviewDashboard/components";

import type { Dealer } from "models";
import type { DealerAdminFormPayload } from "modules/DealerDetails";

const FormHelper = createFormHelper<DealerAdminFormPayload>();

type PonOilProps = {
  tabId: string;
  dealer: Dealer;
};

export const PonOil = ({ tabId, dealer }: PonOilProps) => {
  const { t } = useTranslation();
  const { watch } = FormHelper.useFormContext();
  const [isPonEnabled, ponUsername, ponPassword] = watch(["is_pon_enabled", "pon_username", "pon_password"]);

  const isPonUsernameInvalid = isPonEnabled && !ponUsername;
  const isPonPasswordInvalid = isPonEnabled && !dealer.has_pon_password && !ponPassword;

  return (
    <Element name={tabId} className="dealer-details-section">
      <div className="section-title">
        <div>
          <Icon className="oil can" />
        </div>
        <span className="section-title-text">{t("v8_pon_oil_configuration", "PON Oil configuration")}</span>
      </div>
      <div className="dealer-details-subheading">{t("v8_pon_oil_configuration", "PON Oil configuration")}</div>
      <Form.Group>
        <Form.Field width={16}>
          <FormHelper.Field.Checkbox name="is_pon_enabled" label={t("v8_enable_pon", "Enable PON")} />
        </Form.Field>
      </Form.Group>
      <Form.Group>
        <Form.Field width={8} error={isPonUsernameInvalid}>
          <label>{t("v8_username", "Username")}</label>
          <FormHelper.Field.Input name="pon_username" preventAutofill />
        </Form.Field>
        <Form.Field width={8} error={isPonPasswordInvalid}>
          <label>{t("v8_password", "Password")}</label>
          <FormHelper.Field.Input
            name="pon_password"
            preventAutofill
            inputProps={{ type: "password", placeholder: dealer.has_pon_password ? ASTERISK_PLACEHOLDER : "" }}
          />
        </Form.Field>
      </Form.Group>
    </Element>
  );
};
